import * as ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import './i18n/config';
import { registerPWA, setupInstallPrompt, updateServiceWorker } from './pwaRegistration';
import { showUpdateToast } from './utils/toast';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// Register PWA Service Worker in production
if (import.meta.env.PROD) {
  registerPWA({
    onNeedRefresh: () => {
      // Show toast with callback to activate the new service worker
      showUpdateToast(() => {
        updateServiceWorker();
      });
    },
    onOfflineReady: () => {
      console.log('[PWA] App is ready to work offline');
    }
  });

  // Setup install prompt handler
  setupInstallPrompt(() => {
    console.log('[PWA] Install prompt available');
  });
}

// Note: PWA manifest is dynamically created in courierSlice when courier data loads
// This ensures each courier gets their own customized PWA with their name and branding
